import Column from '@components/Column';
import Text from '@components/Text';
import TextField from '@components/TextField';
import colors from '@constants/colors';
import GiftOrderContext from '@providers/GiftOrderProvider/GiftOrderContext';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

function Message() {
    const { handleChange } = useContext(GiftOrderContext);
    const { t } = useTranslation('gift');
    return (
        <Column fullWidth spacing={12}>
            <Text color={colors.gray7} fontWeight='bold' size='2xl'>
                {t('giftOrder.messageTitle')}
            </Text>
            <TextField placeholder={t('giftOrder.messagePlaceholder')}
                onChange={handleChange}
                as='textarea'
                name='message'
                rows={3}
                maxLength={100}
                showLength />
        </Column>
    );
}

export default Message;
